import React from "react";
import { withLocalize } from "react-localize-redux";
import { connect as connectFormik } from 'formik';
import BbCheckbox from "../../styling/bbCheckbox";
import BbFormikCheckbox from "../../styling/bbFormikCheckbox";
import { unicornCountry } from "../../../store/marketingListStore";

class Rating extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="columns is-multiline">
                    <div className="column is-12" style={{ paddingBottom: 0 }}>
                        <div className="bb-chk-grp-all">
                            <BbCheckbox label={this.props.translate("Charts.CheckAll")} value={this.isAllChecked} id="all-rating" onChange={(c) => this.checkAll(c)} />
                        </div>
                    </div>
                    <div className="column is-6" style={{ paddingTop: 0 }} >
                        <BbFormikCheckbox label="Cribis Index" name="rating.index" id="index" />
                        <BbFormikCheckbox label={this.props.translate("Report.Ratings.SemaphoreCribis")} name="rating.semaphore" id="semaphore" />
                        <BbFormikCheckbox label={`${this.props.translate("Report.Ratings.GroupSemaphoresCribis")} Cribis`} name="rating.groupSemaphore" id="group-semahore" />
                        <BbFormikCheckbox label={`${this.props.translate("Search.Marketing.Bankruptcy")}`} name="rating.bankruptcy" id="bankruptcy" />
                        {unicornCountry() === 'sk' && <BbFormikCheckbox label={this.props.translate("Search.Marketing.PaymentDiscIndex")} name="rating.paymentDiscipline" id="payment-disc" />}
                    </div>
                    <div className="column is-6" style={{ paddingTop: 0 }}>
                        {unicornCountry() === 'cz' && <>
                            <BbFormikCheckbox label={this.props.translate("Search.Marketing.CreditCapacity")} name="rating.creditCapacity" id="loan-capacity" />
                            <BbFormikCheckbox label={this.props.translate("Search.Marketing.ShortTermCredit")} name="rating.shortTermCreditCapacity" id="short-loan-capacity" />
                        </>}
                        {unicornCountry() === 'sk' && <>
                            <BbFormikCheckbox label={this.props.translate("Search.Marketing.LoanLimit.Pro")} name="rating.loanLimitPro" id="loan-limit" />
                            <BbFormikCheckbox label={this.props.translate("Search.Marketing.LoanLimitCons")} name="rating.loanLimitCons" id="loan-limit-2" />
                            <BbFormikCheckbox label={this.props.translate("Search.Marketing.FreeLoanLimitPro")} name="rating.freeLoanLimitPro" id="free-limit" />
                            <BbFormikCheckbox label={this.props.translate("Search.Marketing.FreeLoanLimitCons")} name="rating.freeLoanLimitCons" id="free-limit-2" />
                        </>}
                    </div>
                </div>
            </React.Fragment>
        )
    }

    get isAllChecked() {
        let checkedCount = this.checkboxes.filter(x => x[1] === true).length;
        let allCount = this.checkboxes.length;
        if (checkedCount === 0) { return false };
        if (checkedCount === allCount) { return true };
        return null;
    }

    checkAll(value) {
        let newState = Object.assign({}, this.props.formik.values.rating);
        Object.keys(newState).filter(x => typeof newState[x] === "boolean").map((c) => {
            newState[c] = value;
        });
        this.props.formik.setFieldValue("rating", newState);

    }
    get checkboxes() {
        return Object.entries(this.props.formik.values.rating).filter(x => x[0] !== "isChecked" && typeof x[1] === "boolean");
    }
}

export default withLocalize(connectFormik(Rating));
